import { SA_TRAVEL_FIELDS_MASTER_LIST_SUCCESS, SA_TRAVEL_FIELDS_MASTER_LIST_ERROR, SA_TRAVEL_FIELDS_MASTER_CREATE_SUCCESS, SA_TRAVEL_FIELDS_MASTER_CREATE_ERROR, SA_TRAVEL_FIELDS_MASTER_DELETE_SUCCESS, SA_TRAVEL_FIELDS_MASTER_DELETE_ERROR,  AFFILIATE_TRAVEL_SETTINGS_LIST_SUCCESS, AFFILIATE_TRAVEL_SETTINGS_LIST_ERROR } from '../actions';

const initialState = {
	travelModuleMasterFields:[],
	travelModuleStatus:'',
	travelModuleActivity:'',
  affiliateTravelSettings: {},
};

export default function(state = initialState, action) {
  let timeVar = '~~'+Date.now(); 
  switch(action.type) {    

    case SA_TRAVEL_FIELDS_MASTER_LIST_SUCCESS:
      if(action.response.status && action.response.status===200){
        return {
            ...state, 
            travelModuleMasterFields: action.response.data?.results ? action.response.data.results : action.response.data ? action.response.data :[],
            travelModuleStatus: action.response.data.status ? action.response.data.status : '',  
            travelModuleActivity:SA_TRAVEL_FIELDS_MASTER_LIST_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          travelModuleMasterFields: action.response.data ? action.response.data : [],
          travelModuleStatus: action.response.status ? action.response.status : '',  
          travelModuleActivity:SA_TRAVEL_FIELDS_MASTER_LIST_ERROR+timeVar,  
        }
      }
    case SA_TRAVEL_FIELDS_MASTER_LIST_ERROR:
      return {
        ...state,
        travelModuleMasterFields: action?.response?.data ? action.response.data : [],
        travelModuleStatus: action?.response?.data?.status ? action.response.data.status : '',  
        travelModuleActivity:SA_TRAVEL_FIELDS_MASTER_LIST_ERROR+timeVar,  
      } 


    case SA_TRAVEL_FIELDS_MASTER_CREATE_SUCCESS:
      if(action.response.status && (action.response.status===200 || action.response.status===201)){
        return {
            ...state, 
            travelModuleStatus: action.response.data.detail ? action.response.data.detail : '',  
            travelModuleActivity:SA_TRAVEL_FIELDS_MASTER_CREATE_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          travelModuleStatus: action?.response?.data?.detail ? action.response.data.detail : '',  
          travelModuleActivity:SA_TRAVEL_FIELDS_MASTER_CREATE_ERROR +timeVar,  
        }
      }
    case SA_TRAVEL_FIELDS_MASTER_CREATE_ERROR:
      return {
        ...state,
        travelModuleStatus: action?.response?.data?.detail ? action.response.data.detail : '',  
        travelModuleActivity:SA_TRAVEL_FIELDS_MASTER_CREATE_ERROR+timeVar,  
      }


    case SA_TRAVEL_FIELDS_MASTER_DELETE_SUCCESS:
      if(action.response.status && action.response.status===200){
        return {
            ...state, 
            travelModuleStatus: action.response.data.status ? action.response.data.status : '',  
            travelModuleActivity:SA_TRAVEL_FIELDS_MASTER_DELETE_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          travelModuleStatus: action.response.status ? action.response.status : '',  
          travelModuleActivity:SA_TRAVEL_FIELDS_MASTER_DELETE_ERROR +timeVar,  
        }
      }
    case SA_TRAVEL_FIELDS_MASTER_DELETE_ERROR:
      return {
        ...state,
        travelModuleStatus: action?.response?.data?.status ? action.response.data.status : '',  
        travelModuleActivity:SA_TRAVEL_FIELDS_MASTER_DELETE_ERROR+timeVar,  
      }
    

    case AFFILIATE_TRAVEL_SETTINGS_LIST_SUCCESS:
      if(action.response.status && action.response.status===200){
        return {
            ...state, 
            affiliateTravelSettings: action.response?.data ? action.response.data : {},
            travelModuleStatus: action.response.data.status ? action.response.data.status : '',  
            travelModuleActivity:AFFILIATE_TRAVEL_SETTINGS_LIST_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          affiliateTravelSettings: action.response.data ? action.response.data : {},
          travelModuleStatus: action.response.status ? action.response.status : '',  
          travelModuleActivity:AFFILIATE_TRAVEL_SETTINGS_LIST_ERROR+timeVar,  
        }
      }
    case AFFILIATE_TRAVEL_SETTINGS_LIST_ERROR:
      return {
        ...state,
        affiliateTravelSettings: action?.response?.data ? action.response.data : {},
        travelModuleStatus: action?.response?.data?.status ? action.response.data.status : '',  
        travelModuleActivity:AFFILIATE_TRAVEL_SETTINGS_LIST_ERROR+timeVar,  
      } 
      


    default:
      return state;
  }
};